<template>
  <div>
    <v-container class="py-10">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <h2>10. Digitalisierung als Herausforderung</h2>
          <p>
            Hinweis: Es gibt im aktuellen Farbschema keine monochrome
            Farbpalette mit 5 Farben, deswegen musste ich zwei monochrome Skalen
            mischen.
          </p>
          <p style="color: green">
            <b>UPDATE</b>
          </p>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "DigiChallenge",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "bar"
        },
        title: {
          text:
            "Bitte bewerten Sie, inwiefern das Thema Digitalisierung eine Herausforderung für Ihre Organisation darstellt."
        },
        xAxis: {
          categories: [
            "Digitalisierung allgemein",
            "",
            "Erfüllung Mitarbeiteransprüche an ihren Arbeitsplatz",
            "Zugang zu digitaler Infrastruktur",
            "Erlangung der Kompetenz zur Nutzung digitaler Tools",
            "Nicht absehbare Risiken der Digitalisierung",
            "Zunahme der relevanten Kommunikationskanäle",
            "Aufbringen der erforderlichen Ressourcen zur Investition in Digitalisierung",
            "Einhaltung von Gesetzgebung"
          ],
          labels: {
            align: "left",
            reserveSpace: true,
            style: {
              fontSize: "12"
            }
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        legend: {
          enabled: true,
          reversed: true
        },
        plotOptions: {
          series: {
            stacking: "percent",
            events: {
              legendItemClick: function() {
                return false;
              }
            }
          }
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:12px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true
        },
        colors: ["#546825", "#7d9b38", "#999", "#0391af", "#005a85"],
        series: [
          {
            name: "Sehr große Herausforderung",
            data: [21.1, null, 8.9, 12.2, 23.0, 22.3, 16.4, 29.3, 34.6]
          },
          {
            name: "Große Herausforderung",
            data: [29.6, null, 19.3, 18.8, 23.2, 27.7, 35.2, 30.0, 30.9]
          },
          {
            name: "Mittlere Herausforderung",
            data: [25.4, null, 22.5, 21.7, 21.0, 26.1, 24.6, 20.0, 17.9]
          },
          {
            name: "Geringe Herausforderung",
            data: [14.8, null, 21.6, 18.9, 15.6, 14.8, 14.7, 12.3, 10.5]
          },
          {
            name: "Keine Herausforderung",
            data: [9.1, null, 27.8, 28.3, 17.1, 9.1, 9.1, 8.4, 6.1]
          }
        ],
        exporting: {
          enabled: true,
          fallbackToExportServer: false
        }
      };
    }
  },
  methods: {
    downloadJPEG() {
      this.$refs.chart.chart.exportChart({ type: "image/jpeg" });
    },
    downloadSVG() {
      this.$refs.chart.chart.exportChart({ type: "image/svg+xml" });
    },
    downloadPDF() {
      this.$refs.chart.chart.exportChart({ type: "application/pdf" });
    },
    downloadCSV() {
      this.$refs.chart.chart.downloadCSV();
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
